/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_VisibilityInputs */

const en_story_visibility = /** @type {(inputs: Story_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Visibility`)
};

const es_story_visibility = /** @type {(inputs: Story_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilidad de la Historia`)
};

const fr_story_visibility = /** @type {(inputs: Story_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilité de la Story`)
};

const de_story_visibility = /** @type {(inputs: Story_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story-Sichtbarkeit`)
};

const id_story_visibility = /** @type {(inputs: Story_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilitas Cerita`)
};

/** @type {(inputs: Story_VisibilityInputs) => LocalizedString} */
const ja_story_visibility = en_story_visibility;

/** @type {(inputs: Story_VisibilityInputs) => LocalizedString} */
const zh_story_visibility = en_story_visibility;

/** @type {(inputs: Story_VisibilityInputs) => LocalizedString} */
const ar_story_visibility = en_story_visibility;

/** @type {(inputs: Story_VisibilityInputs) => LocalizedString} */
const it_story_visibility = en_story_visibility;

/** @type {(inputs: Story_VisibilityInputs) => LocalizedString} */
const ru_story_visibility = en_story_visibility;

/** @type {(inputs: Story_VisibilityInputs) => LocalizedString} */
const pt_story_visibility = en_story_visibility;

/** @type {(inputs: Story_VisibilityInputs) => LocalizedString} */
const ko_story_visibility = en_story_visibility;

/**
* | output |
* | --- |
* | "Story Visibility" |
*
* @param {Story_VisibilityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_visibility = /** @type {((inputs?: Story_VisibilityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_VisibilityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_visibility(inputs)
	if (locale === "es") return es_story_visibility(inputs)
	if (locale === "fr") return fr_story_visibility(inputs)
	if (locale === "de") return de_story_visibility(inputs)
	if (locale === "ja") return ja_story_visibility(inputs)
	if (locale === "zh") return zh_story_visibility(inputs)
	if (locale === "ar") return ar_story_visibility(inputs)
	if (locale === "id") return id_story_visibility(inputs)
	if (locale === "it") return it_story_visibility(inputs)
	if (locale === "ru") return ru_story_visibility(inputs)
	if (locale === "pt") return pt_story_visibility(inputs)
	return ko_story_visibility(inputs)
});